import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { concatMap, from, of, Subject, Subscription, take, takeUntil, timer } from 'rxjs';
import axios from 'src/app/Service/axios';
import { SignalrCctvService } from 'src/app/Service/signalr-cctv.service';
import { environment } from 'src/environments/environment';

import { CameraSlot, CctvVehicle, DashCam } from './cctv-cameras.models';

export type { DashCam } from './cctv-cameras.models';

@Component({
  selector: 'app-cctv-cameras',
  templateUrl: './cctv-cameras.component.html',
  styleUrls: ['./cctv-cameras.component.scss'],
  animations: []
})

export class CctvCamerasComponent implements OnInit, OnDestroy {
  listLoading = false;
  listError = '';
  lst_Car: CctvVehicle[] = [];
  lst_Search: CctvVehicle[] = [];
  checkedCameras: CameraSlot[] = [];
  private bulkWaitingCameras = new Set<string>();
  maxCameraSlots: number = 36;
  iTemplateView: number = 4;

  iAttempted: number = 0;
  isLiveStreaming: boolean = false;
  private readonly TIMEOUT_MS = 60000;
  sub!: Subscription;

  isHubConnect: boolean = false;
  isHubEnabled: boolean = ((!!environment?.baseUrlHub) && environment.cctvEnabled);
  private destroy$ = new Subject<void>();
  private hubHandlersBound = false;

  templateActions = [
    { icon: 'fa-arrows-alt', view: 0, label: 'نمایش تمام‌صفحه', action: () => this.openFullscreen() },
    { icon: 'fa-television', view: 36, label: 'نمایش 36 دوربین', action: () => this.updateTemplate(36) },
    { icon: 'fa-bars', view: 18, label: 'نمایش 18 دوربین', action: () => this.updateTemplate(18) },
    { icon: 'fa-th-list', view: 12, label: 'نمایش 12 دوربین', action: () => this.updateTemplate(12) },
    { icon: 'fa-th', view: 9, label: 'نمایش 9 دوربین', action: () => this.updateTemplate(9) },
    { icon: 'fa-th-large', view: 4, label: 'نمایش 4 دوربین', action: () => this.updateTemplate(4) },
    { icon: 'fa-clone', view: 2, label: 'نمایش 2 دوربین', action: () => this.updateTemplate(2) },
    { icon: 'fa-square', view: 1, label: 'نمایش 1 دوربین', action: () => this.updateTemplate(1) },
  ];

  mdl_Request: FormGroup = this._fb.group({
    iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),
    strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
    strUnitID: new FormControl(''),
    tiChannel: new FormControl(''),
    front: new FormControl(''),
    iDeviceCommand: new FormControl(''),
    front_iDeviceCommand: new FormControl(''),
    strUrl: new FormControl(''),
    inside: new FormControl(''),
    inside_iDeviceCommand: new FormControl(''),
    insideUrl: new FormControl(''),
    tiStatus: new FormControl('-1')
  })

  constructor(
    private _tooltip: NotificationService,
    private router: Router,
    private otherService: OtherService,
    private gurdService: GurdServiceService,
    private _fb: FormBuilder,
    private cctvHubService: SignalrCctvService
  ) { }

  ngOnInit(): void {
    if (this.isHubEnabled) {
      this.cctvHubService.init();
      this.cctvHubService.isHubConnected$.pipe(takeUntil(this.destroy$)).subscribe((isConnect: boolean) => {
        this.isHubConnect = isConnect;
        this.registerHubListeners();
      });
    }

    this.updateViewByBreakpoint();
    this.getAllCar(false);
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();

    this.destroy$.next();
    this.destroy$.complete();
  }

  private registerHubListeners() {

    if (this.hubHandlersBound) {
      return;
    }

    this.hubHandlersBound = true;

    this.cctvHubService.hubError$.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      this._tooltip.showError(data)
    });

    this.cctvHubService.dashCamLiveStream$.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      const res = JSON.parse(data.toString());
      this.appendOnlineDashCams(res);
    })

  }

  private updateViewByBreakpoint(): void {

    const breakpoints = [
      { width: 2700, view: this.maxCameraSlots },
      { width: 1700, view: 18 },
      { width: 1500, view: 12 },
      { width: 1300, view: 9 },
      { width: 1100, view: 4 }
    ];

    const matchingBreakpoint = breakpoints.find(bp => window.innerWidth >= bp.width);

    if (matchingBreakpoint) {
      this.iTemplateView = matchingBreakpoint.view;
    }

    else {
      this.iTemplateView = 1;
    }

  }

  async getAllCar(isLive: boolean = false) {
    if (this.listLoading) return;
    this.listLoading = true;
    this.listError = '';
    this.bulkWaitingCameras.clear();
    this.checkedCameras = [];
    this.lst_Car = [];
    this.lst_Search = [];
    this.isLiveStreaming = isLive;
    this.mdl_Request.patchValue({ tiStatus: -1 });

    try {
      const resp = await axios.post(isLive ? 'Dashcam_Live ' : 'Dashcam_List', this.otherService.stringNumberToNumber(this.mdl_Request.value));
      const res = JSON.parse(resp.data);
      if (res.ISSessionExpired == true) {
        this._tooltip.showError('لطفا وارد سیستم شوید');
        this.otherService.removeLocalStorage();
        this.router.navigate(['login'], { queryParams: { error: 'x12q1dss1110' } });
        return;
      }
      if (res.iResult == 0) {
        this.listError = res.strError || 'دریافت خودروها انجام نشد.';
        return;
      }
      this.lst_Car = res;
      this.lst_Search = res;
      this.appendOnlineDashCams(res);
    } catch {
      this.listError = 'دریافت خودروها انجام نشد. اتصال را بررسی و دوباره تلاش کنید.';
    } finally {
      this.listLoading = false;
    }
  }

  async appendOnlineDashCams(response: CctvVehicle[]) {
    response.forEach((car) => {
      if (!car?.Online) return;

      if (car?.Ch1 === 1) {
        const dashCamFront = this.buildDashCam(car, 'front');
        this.updateCheckedList(dashCamFront);
      }

      if (car?.Ch2 === 1) {
        const dashCamInside = this.buildDashCam(car, 'inside');
        this.updateCheckedList(dashCamInside);
      }
    });
  }

  async selectRadio(item: CctvVehicle, channel: 'front' | 'inside') {

    const suffix = channel === 'front' ? '-0' : '-1';
    const targetId = item.strUnitID + suffix;

    const dashCam = this.checkedCameras.find((cam) => cam.strUnitId === targetId);

    if (dashCam) {
      await this.stopStreaming(item, channel);

      const index = this.checkedCameras.indexOf(dashCam);
      if (index !== -1) {
        this.checkedCameras[index].strUnitId = '';
      }
    }

    else {

      if (this.isHubEnabled) {
        await this.sendStartRequest(item, channel)
      }

      else {
        await this.loadOrQueueStream(item, channel);
      }

    }

  }

  async sendStartRequest(item: CctvVehicle, channel: 'front' | 'inside') {

    const model = {
      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
      strUnitID: item.strUnitID,
      tiChannel: channel == 'front' ? 0 : 1,
    }

    this.otherService.Showspinner();

    const resp = await axios.post(`Dashcam_SendCommand4VideoStream`, this.otherService.stringNumberToNumber(model));

    this.otherService.nonespinner();

    const res = JSON.parse(resp.data);

    if (res.ISSessionExpired == true) {
      this._tooltip.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      this.router.navigate(['login'], { queryParams: { error: 'x12qHub1110' } });
      return;
    }

    if (res.iResult == 0) {
      return this._tooltip.showError(res.strError);
    }

    const dashCam = this.buildDashCam(item, channel);
    this.addToCheckedList(dashCam);

  }

  isItemWaiting(item: CctvVehicle): boolean {
    return this.checkedCameras.some((c) => {
      return c.strUnitId.includes(item.strUnitID) && c.strUrl == '';
    })
  }

  async stopStreaming(item: CctvVehicle, channel: 'front' | 'inside') {

    this.otherService.Showspinner();

    const model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      strUnitID: item.strUnitID,

      tiChannel: channel == 'front' ? 0 : 1

    }

    const resp = await axios.post(`Dashcam_CancelVideoStream`, this.otherService.stringNumberToNumber(model));

    this.otherService.nonespinner();

    const res = JSON.parse(resp.data);

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: 'x12q1dss1110' } });

      return;

    }

    if (res.iResult == 0) {

      return this._tooltip.showError(res.strError);

    }

    else {

      this.closeAllChannel(item, channel);

    }

  }

  async closeAllChannel(item: CctvVehicle, channel: 'front' | 'inside') {
    const dashCam = this.checkedCameras.find((cam) => cam.strUnitId == item.strUnitID + (channel == 'front' ? '-1' : '-0'));
    const index = dashCam ? this.checkedCameras.indexOf(dashCam) : -1;
    if (index != -1) {
      this.checkedCameras[index].strUnitId = '';
      this.stopStreaming(item, channel)
    }
  }

  private updateView(bRemoveEmpty: boolean = false) {

    const emptyItem = this.checkedCameras.find((item) => item.strUnitId === '');

    if (emptyItem && bRemoveEmpty) {
      this.emptyUnitId(bRemoveEmpty);
      return;
    }

    if (!bRemoveEmpty && this.checkedCameras.length > this.iTemplateView) {
      const steps = [2, 4, 9, 12, 18];
      const idx = steps.findIndex(v => v > this.iTemplateView);
      this.iTemplateView = idx === -1 ? 36 : steps[idx] ?? 36;
    }
  }

  private emptyUnitId(bRemoveEmpty: boolean = false) {
    const emptyIndex = this.checkedCameras.findIndex((item) => item.strUnitId === '');
    if (emptyIndex !== -1) {
      this.checkedCameras.splice(emptyIndex, 1);
      this.updateView(bRemoveEmpty);
    }
  }

  updateTemplate(iTemplate: number) {
    this.iTemplateView = iTemplate;
    this.updateView(true);

  }

  buildDashCam(item: CctvVehicle, channel: 'front' | 'inside'): DashCam {
    const suffix = channel === 'front' ? '-0' : '-1';
    const targetId = (item.strUnitID ?? item.IMEI) + suffix;
    const channelName = channel === 'front' ? 'وقایع' : 'کابین';
    const finalUrl = this.getDashCamUrl(item, channel) ?? item?.strUrl

    return {
      strUnitId: targetId,
      channel: channelName,
      fullName: item.strFullName ?? '',
      strUrl: finalUrl ?? '',
      iDeviceCommand: 'ندارد',
      tiChannel: suffix.replace('-', ''),
      clients: item.Clients ?? '',
      liveTime: item.StartLiveTime ?? ''
    };
  }

  getDashCamUrl(item: CctvVehicle, channel: 'front' | 'inside'): string {
    if (!item?.Online) return '';

    const isFront = channel === 'front';
    const urlKey = isFront ? 'strCh1FLVURL' : 'strCh2FLVURL';
    const url = item?.[urlKey];
    return typeof url === 'string' ? url : '';
  }

  shouldShowThumb(idx: number): boolean {
    const item = this.checkedCameras?.[idx];
    return !item?.strUnitId || this.isCameraWaiting(idx);
  }

  shouldShowVideo(idx: number): boolean {
    const item = this.checkedCameras?.[idx];
    return !!item?.strUnitId && !!this.isHubEnabled && !!item?.strUrl;
  }

  shouldShowStream(idx: number): boolean {
    const item = this.checkedCameras?.[idx];
    return !!item?.strUnitId && !this.isHubEnabled && !this.bulkWaitingCameras.has(item.strUnitId);
  }

  isCameraWaiting(idx: number): boolean {
    const camera = this.checkedCameras[idx];
    return !!camera?.strUnitId && !camera.strUrl &&
      (this.isHubEnabled || this.bulkWaitingCameras.has(camera.strUnitId));
  }

  private addToCheckedList(dashCam: DashCam) {
    //اگر ظرفیت پر شده
    if (this.checkedCameras.length >= this.maxCameraSlots) {
      const channel = dashCam.strUnitId.includes('-0') ? 'front' : 'inside';
      this.handleSlotsLimit({ strUnitID: dashCam.strUnitId.split('-')[0] }, channel);
      return
    }

    // اگر دوربین قبلاً وجود دارد، کاری انجام نده
    const index = this.checkedCameras.findIndex((item) => item.strUnitId === dashCam.strUnitId);
    if (index !== -1) return;

    // اگر جالی خالی وجود داشت
    const emptyIndex = this.checkedCameras.findIndex((item) => item.strUnitId === '');
    if (emptyIndex !== -1) {
      this.checkedCameras[emptyIndex] = dashCam;
      return;
    }

    // اضافه کردن دوربین اگر هیچ جای خالی نبود
    this.checkedCameras.push(dashCam);

    this.updateView();
    // this.removeDuplicated();
  }

  async loadOrQueueStream(item: CctvVehicle, channel: 'front' | 'inside') {

    const channelKey = channel == 'front' ? 'Ch1' : 'Ch2';

    if (this.checkedCameras.length + 1 <= this.maxCameraSlots) {

      const pendingCamera = this.buildDashCam(item, channel);
      this.addToCheckedList(pendingCamera);
      this.bulkWaitingCameras.add(pendingCamera.strUnitId);
      try {

        const model = {

          iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

          strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

          strUnitID: item.strUnitID,

        }

        const resp = await axios.post(`Dashcam_CheckOnlineFull`, this.otherService.stringNumberToNumber(model));

        const res = JSON.parse(resp.data);

        if (res.ISSessionExpired == true) {

          this.checkedCameras = this.checkedCameras.filter(cam => cam !== pendingCamera);

          this._tooltip.showError('لطفا وارد سیستم شوید');

          this.otherService.removeLocalStorage();

          this.router.navigate(['login'], { queryParams: { error: 'checkOnline_CCTV' } });

          return;

        }

        if (res.iResult == 0) {

          this.checkedCameras = this.checkedCameras.filter(cam => cam !== pendingCamera);

          return this._tooltip.showError(res.strError);

        }

        if (res.Online && res[channelKey]) {
          this.appendOnlineDashCams(Array(res))
        }

        else {
          this.sub = timer(this.TIMEOUT_MS).pipe(take(1)).subscribe(() => {
            this.monitorCamera(pendingCamera.strUnitId);
          });
        }

      } catch {
        this.checkedCameras = this.checkedCameras.filter(cam => cam !== pendingCamera);
        this._tooltip.showError('ارسال فرمان انجام نشد. دوباره تلاش کنید.');
      } finally {
        this.bulkWaitingCameras.delete(pendingCamera.strUnitId);
      }

    }

    else {
      this.handleSlotsLimit(item, channel);
    }

  }

  private handleSlotsLimit(item: CctvVehicle, channel: 'front' | 'inside') {
    const dashCam = this.buildDashCam(item, channel);

    const id = dashCam.strUnitId.split('-')[0] + channel;
    const checkedRadio = document.getElementById(id) as HTMLInputElement | null;
    if (checkedRadio) checkedRadio.checked = false;

    return this._tooltip.showError(`امکان نمایش بیشتر از ${this.maxCameraSlots.toLocaleString('fa-IR')} دوربین وجود ندارد!`);
  }

  private monitorCamera(unitId: string): void {
    const cameraIndex = this.checkedCameras.findIndex(item => item.strUnitId === unitId);

    if (cameraIndex === -1) {
      return;
    }

    const camera = this.checkedCameras[cameraIndex];

    if (!camera.strUrl) {
      console.warn(`Camera ${unitId} removed due to timeout.`);
      this._tooltip.showWarning(`پاسخی دریافت نشد!`, `${camera.fullName} - ${camera.channel}`);

      // دوربین رو از لیست حذف می‌کنیم
      this.checkedCameras.splice(cameraIndex, 1);
    }
  }

  async failedRequest(item: CameraSlot) {
    const idx = this.checkedCameras.findIndex((cam) => cam.strUnitId === item.strUnitId);
    if (idx !== -1) {
      this.checkedCameras[idx] = {
        strUnitId: ''
      };
    }
  }

  async updateCheckedList(item: DashCam) {
    const existingItemIndex = this.checkedCameras.findIndex(cam => cam.strUnitId === item.strUnitId);

    if (existingItemIndex !== -1) {
      this.checkedCameras[existingItemIndex] = item;
    } else {
      this.addToCheckedList(item);
    }
  }

  // deprecated
  async onCameraStatus(status: string | number) {

    // روشن کردن همه دوربین ها
    if (status == 0) {
      const maxSlots = Math.min(this.maxCameraSlots, this.lst_Car.length);
      from(this.lst_Car).pipe(
        take(maxSlots),
        concatMap((car) => {
          const unitFront = car.strUnitID + '-0';
          const unitInside = car.strUnitID + '-1';

          const frontExists = this.checkedCameras.some(c => c.strUnitId === unitFront);
          const insideExists = this.checkedCameras.some(c => c.strUnitId === unitInside);

          if (!frontExists) this.loadOrQueueStream(car, 'front');
          if (!insideExists) this.loadOrQueueStream(car, 'inside');

          // .pipe(delay(1000));
          return of(null)
        })).subscribe({
          error: (err) => {
            console.error('Error processing cars', err);
          },
          complete: () => {
            this._tooltip.showInfo(` درخواست فعالسازی ${maxSlots.toLocaleString('fa-IR')} دوربین ارسال شد.`, '');
          }
        });
    }

    // Bulk commands wait per camera; the acknowledgement is not a stream URL.
    if (status == 1 || status == 2) {
      const channel = status == 1 ? 'front' : 'inside';
      const queuedIds: string[] = [];
      for (const car of this.lst_Car) {
        const camera = this.buildDashCam(car, channel);
        if (this.checkedCameras.some(cam => cam.strUnitId === camera.strUnitId)) continue;
        if (this.checkedCameras.length >= this.maxCameraSlots) break;
        this.addToCheckedList(camera);
        queuedIds.push(camera.strUnitId);
        if (!camera.strUrl) this.bulkWaitingCameras.add(camera.strUnitId);
      }

      const cancelWaiting = () => {
        queuedIds.forEach(id => this.bulkWaitingCameras.delete(id));
        this.checkedCameras = this.checkedCameras.filter(cam => !queuedIds.includes(cam.strUnitId) || !!cam.strUrl);
      };
      try {
        const model = {
          iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),
          strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
          tiChannel: status == 1 ? 0 : 1
        };
        const resp = await axios.post('Dashcam_TurnOnAllCamera', this.otherService.stringNumberToNumber(model));
        const res = JSON.parse(resp.data);
        if (res.ISSessionExpired == true) {
          cancelWaiting();
          this._tooltip.showError('لطفا وارد سیستم شوید');
          this.otherService.removeLocalStorage();
          this.router.navigate(['login'], { queryParams: { error: 'x12zss1110' } });
          return;
        }
        if (res.iResult == 0) {
          cancelWaiting();
          this._tooltip.showError(res.strError);
          return;
        }
        // Keep the existing startup delay before the non-hub loaders poll.
        timer(12000).pipe(takeUntil(this.destroy$)).subscribe(() => {
          queuedIds.forEach(id => this.bulkWaitingCameras.delete(id));
        });
        if (this.isHubEnabled) {
          timer(this.TIMEOUT_MS).pipe(takeUntil(this.destroy$)).subscribe(() => {
            queuedIds.forEach(id => this.monitorCamera(id));
          });
        }
      } catch {
        cancelWaiting();
        this._tooltip.showError('ارسال فرمان انجام نشد. دوباره تلاش کنید.');
      }
    }

    // خاموش کردن همه دوربین ها
    if (status == 3) {

      this.lst_Car.forEach(async (car) => {

        // بررسی شود، دوربین از قبل توسط کاربر خاموش نشده باشد

        const front_camera = this.checkedCameras.find((camera) => { return camera.strUnitId == car.strUnitID + '-0' });

        const inside_camera = this.checkedCameras.find((camera) => { return camera.strUnitId == car.strUnitID + '-1' });

        if (front_camera) {

          await this.stopStreaming(car, 'front');

          const index = this.checkedCameras.indexOf(front_camera);

          if (index != -1) {

            this.checkedCameras.splice(index, 1)

          }

        }

        if (inside_camera) {

          await this.stopStreaming(car, 'inside');

          const index = this.checkedCameras.indexOf(inside_camera);

          if (index != -1) {

            this.checkedCameras.splice(index, 1)

          }

        }

      })

    }

    // خاموش کردن دوربین های وقایع

    if (status == 4) {

      this.lst_Car.forEach(async (car) => {

        // بررسی شود، دوربین از قبل توسط کاربر خاموش نشده باشد

        const camera = this.checkedCameras.find((camera) => { return camera.strUnitId == car.strUnitID + '-0' });

        if (camera) {

          await this.stopStreaming(car, 'front');

          const index = this.checkedCameras.indexOf(camera);

          if (index != -1) {

            this.checkedCameras.splice(index, 1)

          }


        }

      })

    }

    // خاموش کردن دوربین های کابین

    if (status == 5) {

      this.lst_Car.forEach(async (car) => {

        // بررسی شود، دوربین از قبل توسط کاربر خاموش نشده باشد

        const camera = this.checkedCameras.find((camera) => { return camera.strUnitId == car.strUnitID + '-1' });

        if (camera) {

          await this.stopStreaming(car, 'inside');

          const index = this.checkedCameras.indexOf(camera);

          if (index != -1) {

            this.checkedCameras.splice(index, 1)

          }


        }

      })

    }

  }

  filter_list(val: HTMLInputElement) {

    this.lst_Car = this.lst_Search.filter((el) => {

      return (el.strFullName ?? '').includes(val.value) ||

        String(el.strLastCallTime ?? '').includes(val.value)

    });

    if (val.value.trim() == '') {

      this.lst_Car = this.lst_Search;

    }

  }

  isChecked(item: CctvVehicle, channel: 0 | 1): boolean {

    return this.checkedCameras.some((cam) => cam.strUnitId == item.strUnitID + '-' + channel);

  }

  openFullscreen(): void {
    document.getElementById('cctvContainer')?.requestFullscreen?.();
  }

  closeFullscreen(): void {
    document.exitFullscreen?.();
  }

  repeat(n: number): unknown[] {
    return Array(n);
  }

  getColor(item: CctvVehicle): string {
    const front = item.strUnitID + '-0';
    const inside = item.strUnitID + '-1';
    const a = this.checkedCameras.some((c) => c.strUnitId == front);
    const b = this.checkedCameras.some((c) => c.strUnitId == inside);
    if (a !== b) return '#ccd9ff';
    if (a && b) return '#c2ffc2';
    return '#f5f5f5';
  }

  openCar(item: CctvVehicle) {
    const urlTree = this.router.createUrlTree([
      'carInfo',
      item.strUnitID
    ]);
    const serializedUrl = this.router.serializeUrl(urlTree)
    window.open(serializedUrl, '_blank');
  }

  async updateTime(event: Event, item: CctvVehicle, index: number) {

    event.stopPropagation();

    this.otherService.Showspinner();

    const model = {

      ID: this.gurdService.decrypt(localStorage.getItem('ID')!),

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      strUnitID: item.strUnitID,

    };

    const resp = await axios.post(`GetCar?strUnitID=${item.strUnitID}`, model);

    this.otherService.nonespinner();

    if (resp.data.ISSessionExpired == true) {

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: '1w2' } });

      return;

    }

    if (resp.data == null) {

      this._tooltip.showError('بروز خطا در سامانه');

      return;

    }

    const res = resp.data;

    this.lst_Car[index].strDate = res.strDate;
    this.lst_Car[index].strTime = res.strTime;


  }

  getColClass(view: number): string {
    switch (view) {
      case 1:
      case 2:
        return 'col-12';
      case 4:
        return 'col-6';
      case 9:
        return 'col-4';
      case 12:
        return 'col-3';
      case 18:
        return 'col-2';
      case 36:
        return 'col-1';
      default:
        return 'col-12';
    }
  }

  getRowDiv(view: number): number {
    switch (view) {
      case 1: return 1;
      case 2: return 2.02;
      case 4: return 2;
      case 9: return 3;
      case 12: return 3;
      case 18: return 3;
      case 36: return 3;
      default: return 2;
    }
  }


}
